import { useTranslation } from 'react-i18next';
import { getFullname, getNameInitials, padNumber } from '@/helpers/utils';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { Avatar } from '@/components/UI/Avatar';
import { RoundButton } from '@/components/UI/RoundButton';
import { submitEmailVerification } from '@/store/services/userServices';
import { SuccessIcon } from '@/components/UI/Icons';
import { EMPTY_DASH } from '@/helpers/constants';
import { useRoundStatus } from '@/hooks/shared/useRoundStatus';
import { useGetMe } from '@/hooks/useGetMe';
import { useWindowSize } from '@/hooks/useWindowSize';
import './index.scss';

// TODO добавить описание текст (104)
const ProfileHeader = ({ onPhotoChange }) => {
  const { t } = useTranslation('profile');
  const { profile: user, isEmailVerified } = useGetMe();
  const { innerWidth } = useWindowSize();
  const { isParticipating } = useRoundStatus();
  const { openSingleModal } = useModal();

  const onEmailVerify = () => {
    submitEmailVerification();
  };
  const onEmailChange = () => {
    openSingleModal(MODAL_IDS.change_email_modal);
  };

  return (
    <div className="profile_header">
      <div className="profile_header__avatar">
        <Avatar
          size={innerWidth < 992 ? 160 : 260}
          alt="avatar"
          image={user?.photo}
          nameInitials={getNameInitials(user?.first_name, user?.last_name)}
          active={isParticipating}
        />
        {user && (
          <button
            type="button"
            className="profile_header__avatar_camera"
            onClick={onPhotoChange}
          >
            <svg
              width="35"
              height="27"
              viewBox="0 0 35 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9784 0H22.0216C22.6417 0 23.4555 0.403594 23.8372 0.90125L26.3222 4.56531C26.565 4.92187 26.9686 5.13844 27.3995 5.13844H32.7436C33.9905 5.13844 34.9989 6.15562 34.9989 7.41672V23.9717C34.9989 25.2306 33.9905 26.2511 32.7436 26.2511H2.25641C1.00953 26.2511 0 25.2328 0 23.9717V7.41672C0 6.15781 1.00953 5.13844 2.25641 5.13844H7.62234C8.03906 5.13844 8.42953 4.93062 8.66578 4.585L11.1617 0.90125C11.5445 0.404687 12.3616 0 12.9784 0ZM25.9678 7.99093C25.9678 8.62093 26.4731 9.13171 27.0965 9.13171C27.721 9.13171 28.2253 8.62093 28.2253 7.99093C28.2253 7.36093 27.721 6.84906 27.0965 6.84906C26.4731 6.84906 25.9678 7.36093 25.9678 7.99093ZM9.59654 15.4088C9.59654 19.821 13.1348 23.3975 17.5 23.3975C21.8651 23.3975 25.4023 19.821 25.4023 15.4088C25.4023 10.9955 21.8651 7.42002 17.5 7.42002C13.1348 7.42002 9.59654 10.9955 9.59654 15.4088ZM11.2908 15.4088C11.2908 11.9405 14.07 9.13175 17.5 9.13175C20.93 9.13175 23.7092 11.9405 23.7092 15.4088C23.7092 18.876 20.93 21.6858 17.5 21.6858C14.07 21.6858 11.2908 18.876 11.2908 15.4088Z"
                fill="#000"
              />
            </svg>
          </button>
        )}
      </div>

      <div className="profile_header__right">
        <div className="profile_header__name">
          <h1 className="f-42 f-500 tl">
            {getFullname(user?.first_name, user?.last_name, EMPTY_DASH)}
          </h1>
        </div>
        <div className="profile_header__email">
          <div className="f-14 f-400">{t('email')}</div>
          <div className="profile_header__email_verification">
            <div className="f-16 f-400">{user ? user.email : '-'}</div>
            {!isEmailVerified ? (
              <RoundButton
                className="profile_header__email_verify"
                label={() => t('verify')}
                fillBackground
                onClick={onEmailVerify}
              />
            ) : (
              <>
                <SuccessIcon className="profile_header__email_verified" />
                <button
                  className="profile_header__email_change"
                  onClick={onEmailChange}
                >
                  {t('change_email')}
                </button>
              </>
            )}
          </div>
        </div>

        <div className="profile_header__account">
          <div className="f-14 f-400">{t('your_scramble_account_number')}</div>
          <div>
            <span className="f-16 f-400">
              {user ? padNumber(user.id) : EMPTY_DASH}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
